import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SignOutSvg = () => (
  <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
    <path fill='transparent' d='M0 0h24v24H0z' />
    <path
      fill='currentColor'
      d='M16 17v2a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h9a2 2 0 012 2v2h-2V5H5v14h9v-2h2zm2.5-10.5l-1.414 1.414L20.172 11H10v2h10.172l-3.086 3.086L18.5 17.5 24 12l-5.5-5.5z'
    />
  </svg>
);

export const SignOutIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SignOutSvg} {...props} />
);
